import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ListAttachment, ListEntryTypes, ListProperty } from '@site-mate/dashpivot-shared-library';

import { DateExpirationService, ExpirationModes } from '../date-expiration.service';

@Component({
  selector: 'cc-list-field-placeholder',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './list-field-placeholder.component.html',
  styleUrls: ['./list-field-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListFieldPlaceHolderComponent {
  @Output() loadComponent = new EventEmitter<void>();
  @Input() property: ListProperty;
  readonly ListEntryTypes = ListEntryTypes;
  dateExpiryClass: ExpirationModes;
  propertyValue = '';
  placeHolderText = '';
  attachmentValues: ListAttachment[] = [];

  private readonly placeHolderMap: Record<ListEntryTypes, string> = {
    [ListEntryTypes.Text]: 'Add text...',
    [ListEntryTypes.Number]: 'Add number...',
    [ListEntryTypes.Date]: 'Select date...',
    [ListEntryTypes.DateExpiry]: 'Select date...',
    [ListEntryTypes.Attachment]: 'Add attachment...',
  };

  constructor(private readonly dateExpirationService: DateExpirationService) {}

  ngOnInit() {
    this.placeHolderText = this.placeHolderMap[this.property.kind];
    this.setPropertyValue();
    this.setDateExpiryClass();
  }

  onFieldClick(event: MouseEvent) {
    event.stopPropagation();
    this.loadComponent.emit();
  }

  private setPropertyValue() {
    if (this.property.kind === ListEntryTypes.Attachment) {
      this.attachmentValues = (this.property.value || []) as ListAttachment[];
      return;
    }

    const propertyValueMapper = {
      [ListEntryTypes.Text]: this.property.value,
      [ListEntryTypes.Number]: this.property.value,
      [ListEntryTypes.Date]: this.getDateValue(),
      [ListEntryTypes.DateExpiry]: this.getDateValue(),
    };

    this.propertyValue = String(propertyValueMapper[this.property.kind] ?? '');
  }

  private getDateValue(): string {
    if (!this.property.value) {
      return '';
    }

    return new Date(String(this.property.value)).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: this.dateExpirationService.timezone(),
    });
  }

  onTab(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      this.loadComponent.emit();
    }
  }

  private setDateExpiryClass() {
    if (this.property.kind === ListEntryTypes.DateExpiry && this.property.value) {
      this.dateExpiryClass = this.dateExpirationService.getExpirationMode(String(this.property.value));
    }
  }
}
